import { useEffect, useState } from "react";
import { emailValidation } from "~/lib";
import { Modal } from "~/rs-components/global";


type TypeSuggestSubscribe = {
    customerAccessToken: string | undefined
}
const STATE_SUBSCRIBED = "SUBSCRIBED";

export function SuggestSubscribe({ customerAccessToken }: TypeSuggestSubscribe) {

    const [email, setEmail] = useState('');
    const [sended, setSended] = useState(false);
    const [loading, setloading] = useState(false);

    const [active, setActive] = useState<boolean>(false);
    const [expirationDate, setExpirationDate] = useState('');

    useEffect(() => {
        const isLogged = (customerAccessToken == undefined || customerAccessToken == "") ? false : true;
        if (!isLogged) {
            verificationAceptCookies();
        }
    }, []);



    function closePay() {
        setActive(false)
    }

    const onChange = (event) => {
        setEmail(event.target.value)

    }

    const emailMarketingConsent = {
        state: STATE_SUBSCRIBED
    }
    const send = async () => {
        setloading(true)

        const result = await callAccountCreateApi({ email, emailMarketingConsent });
        setSended(true);
        setEmail('')
        setloading(false)
        saveCookies()

        setTimeout(function () {
            setActive(false)
        }, 2000);
    }


    const saveCookies = () => {
        document.cookie = `suggestsubscribe=true; expires=${expirationDate}; path=/`;
    };

    const getexpirationDate = () => {

        const OneYearMilisecond = 365 * 24 * 60 * 60 * 1000;
        const actualDate = new Date();
        const expirationDate = new Date(actualDate.getTime() + OneYearMilisecond);
        const expirate = expirationDate.toISOString().slice(0, 10);
        return expirate;
    };


    const verificationAceptCookies = () => {
        const cookies = document.cookie.split(';');
        for (const cookie of cookies) {
            const [name, value] = cookie.split('=');
            if (name.trim() === 'suggestsubscribe' && value.trim() === 'true') {
                setActive(false);
                return;
            }
        }

        setExpirationDate(getexpirationDate());
        setActive(true);
    };

    return (
        <>
            {active &&

                <div className="subscribe-modal">
                    <Modal close={closePay}>
                        <div className="card">
                            <div className="card-content">
                                <h1>Welcome</h1>
                                <p>Sign up for our emails.</p>
                                <p>Be the first to know about online exclusives, new products, events and much more.</p>
                                <form onSubmit={send}>
                                    <input type="email"
                                        className="input-field"
                                        onChange={onChange} value={email} placeholder="email address" required />
                                    <button type="submit" className="submit-button">Sign me up!</button>
                                </form>
                                {loading ? <div className="text-white text-base">Subscribing ...</div> :
                                    sended ? <div className="text-white text-base">Thanks for subscribing</div> :
                                        <></>
                                }

                            </div>
                        </div>
                    </Modal>
                </div>
            }
        </>
    )
}


async function callAccountCreateApi(
    {
        email,
        emailMarketingConsent
    }
        : {
            email: string,
            emailMarketingConsent: any
        }) {

    try {
        const res = await fetch(`/account/register`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, emailMarketingConsent }),
        });
        if (res.status === 200) {
            return res.ok;
        } else {
            return res.json();
        }
    } catch (error: any) {
        return {
            error: error.toString(),
        };
    }
}